import getEnv from './get-env';

/**
 * Construct a url joining a given path with the base env bucket url
 *
 * @param path Path of the asset after the bucket base url
 * @param basePath Optional base path to use taking precedent over the env asset bucket
 * @returns {Promise<string>}
 */
export default async function getAsset(path = '', basePath) {
  if (basePath) {
    return `${basePath}/${path}`;
  }
  const env = await getEnv();
  return `${env.VUE_APP_ASSET_BUCKET || ''}/${path}`;
}
